import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DataTable, { TableColumn } from "react-data-table-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../style/Dentisstyle.css";
import { apiAxios } from "../../utils/apiAxios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface Notification {
  notificationID: number;
  notification: string;
  createdDate: string;
  isApprove: boolean;
  isReject: boolean;
  hubName: string;
  sentByName: string;
  seenByNames: string;
  createdByName: string;
  patientID: number;
  patientName: string;
  age: number;
  gender: string;
  mobileNumber: string;
  emailID: string;
  tooth: string;
  toothsCount: number;
  status: string | null;
  patientRejectStatus: string | null;
  rejectReason: string | null;
  patientApproveStatus: string | null;
  clinicName: string;
  clinicID: number;
  restorationTypeID: number;
  materialName: string;
  shadeName: string;
}


const getStatusBadge = (item: Notification) => {
  if (item.isApprove) return <span className="badge bg-success">Accepted</span>;
  if (item.isReject) return <span className="badge bg-danger">Rejected</span>;
  return <span className="badge bg-warning text-dark">Pending</span>;
};


const NotificationDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchNotifications = async () => {
    if (!id) return;
    setLoading(true);
    try {
      const response = await apiAxios.post(`${API_BASE_URL}/Patient/GetPatientDetailsByNotificationID`, {
        NotificationID: Number(id),
      });

      const data = Array.isArray(response.data) ? response.data : [];
      setNotifications(data);
    } catch (error) {
      console.warn("Error fetching notifications:", error);
      toast.error("Failed to fetch notifications");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, [id]);

  const filteredNotifications = notifications.filter((item) =>
    item.notification.toLowerCase().includes(searchTerm.toLowerCase())
  );


  //  const conditionalRowStyles: ConditionalStyles<Notification>[] = [
  //   {
  //     when: (row) => row.notificationID % 2 === 0,
  //     style: { backgroundColor: "#ffffff" },
  //   },
  //   {
  //     when: (row) => row.notificationID % 2 !== 0,
  //     style: { backgroundColor: "#f5f5f5" },
  //   },
  // ];



  const customStyles = {
    headRow: {
      style: {
        // backgroundColor: "#3D8BFD",
        // color: "white",
        fontSize: "15px",
        paddingTop: "12px",
        paddingBottom: "12px",
      },
    },

    headCells: {
      style: {
        paddingLeft: "14px",
        paddingRight: "14px",
        justifyContent: "center",

      },
    },


  };

  const columns: TableColumn<Notification>[] = [
    { name: "ID", selector: (row) => row.notificationID, sortable: true, width: "100px", center: true },
    { name: "Notification", selector: (row) => row.notification, sortable: true, wrap: true, width: "160px" },
    { name: "Hub", selector: (row) => row.hubName, sortable: true, width: "160px", center: true },
    { name: "Sent By", selector: (row) => row.sentByName, sortable: true, width: "160px", center: true },
    { name: "Clinic Name", selector: (row) => row.clinicName, width: "160px", center: true },
    { name: "Patient Name", selector: (row) => row.patientName, sortable: true, width: "160px", center: true },
    { name: "Patient Email", selector: (row) => row.emailID, width: "160px", center: true },
    { name: "Tooth", selector: (row) => row.tooth, width: "160px", center: true },
    { name: "Tooths Count", selector: (row) => row.toothsCount, width: "150px", center: true },
    { name: "Material Name", selector: (row) => row.materialName, width: "160px", center: true },
    { name: "Shade Name", selector: (row) => row.shadeName, width: "160px", center: true },
    { name: "Status", cell: (row) => getStatusBadge(row), width: "120px", sortable: true, center: true },
  ];


  return (
    <div className="container ">
      <h4 className="mb-3">Notification Details</h4>

      <div className="row mb-3">
        <div className="col-md-4">
          <div className="input-group">
            <input
              type="text"
              placeholder="Search Notification..."
              className="form-control"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => setSearchTerm("")}
              >
                Clear
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="card shadow mt-3">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={filteredNotifications}
            pagination
            highlightOnHover
            striped
            dense
            progressPending={loading}
            noDataComponent={searchTerm ? `No notifications found for "${searchTerm}"` : "No notifications found"}
            // conditionalRowStyles={conditionalRowStyles}
            customStyles={customStyles}
            className="dentisttable-custom2"
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationDetail;
